import React from 'react';

type NavigationTabsContextProps = {
  activeTabId: string;
  onChange?: (tabName: string) => void;
};

export const NavigationTabsContext = React.createContext<NavigationTabsContextProps | undefined>(
  undefined,
);

export function useNavigationTabsContext() {
  const context = React.useContext(NavigationTabsContext);

  if (!context) {
    throw new Error('useNavigationTabsContext must be used within a HorizontalTabs');
  }

  return context;
}
